export default __webpack_public_path__ + "static/media/093-down-arrow-2.ad6eb0d4.png";